/*
Configurations based on input params.
Input params can be querystring or gateway messages.
*/
export default {
  default: {
    locale: 'en',
    timezoneOffset: 1,
    wheel: {
      id: 1,
      wheelAccountId: 1,
      platformCompanyUuid: 'f0a2c9ff-cbf7-417e-b9ec-867c27bbe9ca',
    },
  },
  expo: {
    locale: 'en',
    timezoneOffset: 1,
    wheel: {
      id: 1,
      wheelAccountId: 1,
      platformCompanyUuid: 'b99752b3-443c-4c80-b559-945a95c4b805',
      accounts: ['Expo'],
    },
  },
  superbet: {
    locale: 'ro',
    timezoneOffset: 3,
    wheel: {
      id: 2,
      wheelAccountId: 40,
      platformCompanyUuid: 'fb68cb4c-0002-42fb-abc3-1cdd7aea0356',
      accounts: ['Superbet'],
    },
  },
  superbetWeb: {
    locale: 'ro',
    timezoneOffset: 3,
    wheel: {
      id: 172,
      wheelAccountId: 950,
      platformCompanyUuid: '7f38c596-5e18-4eba-a94f-feba42432938',
      accounts: ['Superbet Web'],
    },
  },
  isy: {
    locale: 'en',
    timezoneOffset: -4,
    wheel: {
      id: 5,
      wheelAccountId: 16,
      platformCompanyUuid: '1d9a58ae-9a22-4ed5-b5d2-4e9eb6664240',
      accounts: ['Isy Paryaj'],
    },
  },
  sima: {
    locale: 'en',
    timezoneOffset: 2,
    wheel: {
      id: 7,
      wheelAccountId: 13,
      platformCompanyUuid: '8370ebb8-1ef5-4ff1-9c6a-ff21039f0914',
      accounts: ['Sima Communication'],
    },
  },
  plezi: {
    locale: 'en',
    timezoneOffset: -4,
    wheel: {
      id: 8,
      wheelAccountId: 62,
      platformCompanyUuid: '41eedf84-13e5-4e68-8e31-1e3e1a60745b',
      accounts: ['Plezi Paryaj'],
    },
  },
  livebet1x2: {
    locale: 'ro',
    timezoneOffset: 3,
    wheel: {
      id: 24,
      wheelAccountId: 98,
      platformCompanyUuid: '86afd4cc-c0ab-4745-bf04-e8e7f10839f6',
      accounts: [
        'Livebet 1x2',
      ],
    },
  },
  betsplus: {
    locale: 'en',
    timezoneOffset: 2,
    wheel: {
      id: 6,
      wheelAccountId: 52,
      platformCompanyUuid: '439257cd-5d38-4701-875b-3e97f06433e3',
      accounts: [
        'Bets Plus',
      ],
    },
  },
  bingobet: {
    locale: 'ro',
    timezoneOffset: 3,
    wheel: {
      id: 17,
      wheelAccountId: 84,
      platformCompanyUuid: '6c78d15c-4421-40e7-92f0-4def495b1a18',
      accounts: [
        'Bingo Bet',
      ],
    },
  },
  aceline: {
    locale: 'en',
    timezoneOffset: 2,
    wheel: {
      id: 21,
      wheelAccountId: 88,
      platformCompanyUuid: '6c78d15c-4421-40e7-92f0-4def495b1a18',
      accounts: [
        'Aceline',
      ],
    },
  },
  balkanbet: {
    locale: 'sr',
    timezoneOffset: 2,
    wheel: {
      id: 28,
      wheelAccountId: 111,
      platformCompanyUuid: '4f54c6aa-82a9-475d-bf0e-dc02ded89225',
      accounts: [
        'Balkan Bet',
      ],
    },
  },
  luckyland: {
    locale: 'en',
    timezoneOffset: 3,
    wheel: {
      id: 12,
      wheelAccountId: 73,
      platformCompanyUuid: '5d39ce79-c44a-4be0-a3ba-9dbc5ddd5c0c',
      accounts: [
        'Luckyland Gaming',
      ],
    },
  },
  belparyaj: {
    locale: 'en',
    timezoneOffset: -4,
    wheel: {
      id: 35,
      wheelAccountId: 159,
      platformCompanyUuid: 'e0bdbc80-6588-4e12-9636-e76f217c7c5',
      accounts: [
        'Bel Paryaj',
      ],
    },
  },
  pozeparyaj: {
    locale: 'en',
    timezoneOffset: -4,
    wheel: {
      id: 31,
      wheelAccountId: 155,
      platformCompanyUuid: '9909363e-3471-4b12-9c41-8b46475122e6',
      accounts: [
        'Poze Paryaj',
      ],
    },
  },
  modelparyaj: {
    locale: 'en',
    timezoneOffset: -4,
    wheel: {
      id: 88,
      wheelAccountId: 575,
      platformCompanyUuid: '5f4bd4c0-d85f-48c0-a0b1-b05f3ead1c22',
      accounts: [
        'Model Paryaj',
      ],
    },
  },
};
